/**
 * functions
 */
import { updateLazy } from '../functions/lazy';
import { initTippy } from '../functions/tippy';
import smoothscroll from 'smoothscroll-polyfill';

/**
 * common & components
 */
import 'Common/eshop';
import 'Common/window';
import 'Common/info-messages';
import 'Common/toggle-password';

import 'Common/product-cart-quantity';
import 'Common/spinner-quick-update';

import 'Components/modal/modal-back';
import 'Components/modal/modal-jump';
import 'Components/modal/modal-open-from-hash';

import 'Components/header';
import 'Components/footer';
import 'Components/form/login';

/**
 * script
 */
window.Cart.customCallbacks.addedItem = function (form, response) {
    window.rEvent.dispatch('Custom.Cart.addedItem', { form, response })
}
window.Cart.customCallbacks.updatedItem = function (input, response) {
    window.rEvent.dispatch('Custom.Cart.updatedItem', { input, response })
}
window.Cart.customCallbacks.removedItem = function (form, response) {
    window.rEvent.dispatch('Custom.Cart.removedItem', { form, response })
}

window.updateLazy = updateLazy();

document.addEventListener('DOMContentLoaded', () => {
    updateLazy();
    initTippy()
});

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.js-back').forEach(back => {
        back.addEventListener('click', event => {
            if (event.currentTarget.getAttribute('href') == '#') {
                window.history.back()
            }
        })
    })
})

smoothscroll.polyfill();
